// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.nav-link.active, .nav-pills .show > .nav-link {
  background: var(--unnamed-color-2c906b) 0% 0% no-repeat padding-box !important;
  background: #2C906B 0% 0% no-repeat padding-box !important;
  border-radius: 16px 16px 0px 0px;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #A0D7C7 !important;
  padding-top: 18px !important;
  border: none;
}

.nav-link {
  background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border-radius: 16px 16px 0px 0px !important;
  opacity: 1;
  text-align: center;
  letter-spacing: 0px;
  color: #2C906B;
  padding-top: 18px !important;
}

.nav-item {
  width: 194px;
  height: 60px;
}
.nav-item:hover {
  color: #2C906B;
  background-color: #A0D7C7;
  border: none;
}

.nav-tabs {
  border-radius: 16px 16px 0px 0px;
  background: #fff 0% 0% no-repeat padding-box;
  border-bottom-color: #2C906B;
  border-bottom-width: 1px;
}

.mt-2 {
  margin-top: 0px !important;
}

.location-update-msg {
  top: 10px;
  right: 18px;
  position: absolute;
  width: 280px;
  height: 105px;
  background: var(--unnamed-color-2c906b) 0% 0% no-repeat padding-box;
  background: #2C906B 0% 0% no-repeat padding-box;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.1019607843);
  border-radius: 6px;
  opacity: 1;
  cursor: pointer;
}

.msg-title {
  text-align: left;
  font: normal normal bold 16px/19px Helvetica Neue, sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  padding-left: 20px;
  padding-top: 20px;
}

.msg-text {
  text-align: left;
  font: normal normal normal 16px/18px Helvetica Neue, sans-serif;
  letter-spacing: 0px;
  color: #FFFFFF;
  opacity: 1;
  padding-left: 20px;
  padding-bottom: 20px;
  padding-right: 20px;
  padding-top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/core/hht/itinerary/itinerary.component.scss"],"names":[],"mappings":"AACA;EACI,8EAAA;EACA,0DAAA;EACA,gCAAA;EACA,UAAA;EAEA,kBAAA;EAEA,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,YAAA;AAFJ;;AAKA;EACI,mEAAA;EACA,+CAAA;EACA,2CAAA;EACA,UAAA;EAEA,kBAAA;EAEA,mBAAA;EACA,cAAA;EACA,4BAAA;AAJJ;;AAOA;EACI,YAAA;EACA,YAAA;AAJJ;AAMI;EACI,cAAA;EACA,yBAAA;EACA,YAAA;AAJR;;AAQA;EACI,gCAAA;EACA,4CAAA;EACA,4BAAA;EACA,wBAAA;AALJ;;AAQA;EACI,0BAAA;AALJ;;AAQA;EACI,SAAA;EACA,WAAA;EACA,kBAAA;EACA,YAAA;EACA,aAAA;EACA,mEAAA;EACA,+CAAA;EACA,oDAAA;EACA,kBAAA;EACA,UAAA;EACA,eAAA;AALJ;;AAQA;EAEI,gBAAA;EACA,6DAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,iBAAA;AANJ;;AASA;EAEI,gBAAA;EACA,+DAAA;EACA,mBAAA;EACA,cAAA;EACA,UAAA;EACA,kBAAA;EACA,oBAAA;EACA,mBAAA;EACA,iBAAA;AAPJ","sourcesContent":["\n.nav-link.active, .nav-pills .show > .nav-link {\n    background: var(--unnamed-color-2c906b) 0% 0% no-repeat padding-box !important;\n    background: #2C906B 0% 0% no-repeat padding-box !important;\n    border-radius: 16px 16px 0px 0px;\n    opacity: 1;\n    // color: var(--unnamed-color-a0d7c7);\n    text-align: center;\n    // font: normal normal normal 16px/18px Helvetica Neue;\n    letter-spacing: 0px;\n    color: #A0D7C7 !important;\n    padding-top: 18px !important;\n    border: none;\n}\n\n.nav-link{\n    background: var(--unnamed-color-ffffff) 0% 0% no-repeat padding-box;\n    background: #FFFFFF 0% 0% no-repeat padding-box;\n    border-radius: 16px 16px 0px 0px !important;\n    opacity: 1;\n    // color: var(--unnamed-color-2c906b);\n    text-align: center;\n    // font: normal normal normal 16px/18px Helvetica Neue;\n    letter-spacing: 0px;\n    color: #2C906B;\n    padding-top: 18px !important;\n}\n\n.nav-item{\n    width: 194px;\n    height: 60px;\n\n    &:hover{\n        color: #2C906B;\n        background-color: #A0D7C7;\n        border: none;\n    }\n}\n\n.nav-tabs{\n    border-radius: 16px 16px 0px 0px;\n    background: #fff 0% 0% no-repeat padding-box;\n    border-bottom-color: #2C906B;\n    border-bottom-width: 1px;\n}\n\n.mt-2{\n    margin-top: 0px !important;\n}\n\n.location-update-msg{\n    top: 10px;\n    right: 18px;\n    position: absolute;\n    width: 280px;\n    height: 105px;\n    background: var(--unnamed-color-2c906b) 0% 0% no-repeat padding-box;\n    background: #2C906B 0% 0% no-repeat padding-box;\n    box-shadow: 0px 5px 10px #0000001A;\n    border-radius: 6px;\n    opacity: 1;\n    cursor: pointer;\n}\n\n.msg-title{\n    // color: var(--unnamed-color-ffffff);\n    text-align: left;\n    font: normal normal bold 16px/19px Helvetica Neue,sans-serif;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n    opacity: 1;\n    padding-left: 20px;\n    padding-top: 20px;\n}\n\n.msg-text{\n    // color: var(--unnamed-color-ffffff);\n    text-align: left;\n    font: normal normal normal 16px/18px Helvetica Neue,sans-serif;\n    letter-spacing: 0px;\n    color: #FFFFFF;\n    opacity: 1;\n    padding-left: 20px;\n    padding-bottom: 20px;\n    padding-right: 20px;\n    padding-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
